// src/adminApi.js
const BASE_URL = '/api/v1/admin'; // Убедитесь, что ваш dev-сервер или nginx проксирует /admin на бэкенд

async function fetchAdminAPI(path, method = 'GET', body = null, telegramAuth) {
    const headers = {
        'Content-Type': 'application/json',
    };
    if (telegramAuth) {
        headers['X-Telegram-Auth'] = telegramAuth;
    }

    const options = {
        method,
        headers,
    };

    if (body && (method === 'POST' || method === 'PATCH' || method === 'PUT')) {
        options.body = JSON.stringify(body);
    }

    let fullPath = `${BASE_URL}${path}`;
    if (body && method === 'GET' && Object.keys(body).length > 0) { // для GET параметров в query
        const queryParams = new URLSearchParams(body).toString();
        fullPath += `?${queryParams}`;
    }


    try {
        const response = await fetch(fullPath, options);
        if (response.status === 204) { // No Content
            return { success: true, data: null };
        }
        const data = await response.json();
        if (!response.ok) {
            return { success: false, message: data.message || `Error: ${response.status}`, data };
        }
        return { success: true, data };
    } catch (error) {
        console.error(`API call to ${path} failed:`, error);
        return { success: false, message: error.message || 'Network error' };
    }
}

export default fetchAdminAPI;